import { useTranslation } from 'react-i18next';

import { Errors } from '../types';

export const ErrorBlock = ({ error }: { readonly error: Errors }) => {
  const { t } = useTranslation();
  const getMessage = (errorCase: Errors): string => {
    switch (errorCase) {
      case 'no-expression':
        return t('report.blocks.measureBreakdown.noExpression');
      case 'wrong-expression':
        return t('report.blocks.measureBreakdown.wrongExpression');
      default:
        ((value: never): never => {
          throw new Error(`Unhandled case: ${value}`);
        })(errorCase);
    }
  };
  return <div>{getMessage(error)}</div>;
};
